import React               from 'react';
import {connect}           from 'react-redux';
import {Redirect,Link}     from 'react-router-dom';
import $                   from 'jquery';
import moment              from 'moment';
import RenderHeader        from '../../../container/renderHeader';
import RenderFilter        from '../../../container/renderFilter';
import { GetTarefasAluno } from '../../../actions/tarefaAction';
import { SetError }        from '../../../actions/notificacaoAction';
import { GetActionBg,
         GetCheckSelect,
         PaginateElement }  from '../../../actions/scopoAction';
import bg_missao           from "../../../img/bg/bg_missao.png";
import registro            from "../../../img/global/registro.png";
import AcaoMissao          from './missao_acao';
import FlashCarregando     from '../../../container/FlashCarregando';


class Tarefas_Aluno  extends React.Component{

    constructor(props){
        super(props);
        this.state = {
                      load:false,
                      acao:false,
                      elemtPagination:'...',
                      listaPagination:<FlashCarregando/>,
                      limitPag:4
                    }      
    }

    componentWillMount(){

        this.props.GetTarefasAluno(this.props.session.turma).then((response) =>{
             this.setState({load:true,statusElem:null});   
            // this.renderIntemMissao(1);     
        }).catch((error) =>{
            this.props.SetError(500);
        });

        this.props.GetActionBg(bg_missao);
        this.props.GetCheckSelect(null);
    }

    click(val){

      this.setState({acao:true,tar_id:val})
    }

    paginacao(array){

        var elem = []
        var ar = Math.round(array.length/this.state.limitPag);

        for(var i=1; i<=ar; i++){elem.push(i);}        
        const retornoElem = elem.map((elem,i)=>{
            var count = (ar == 1?void(0):(elem ==1 || elem == ar ? this.renderIntemMissao.bind(this,elem): this.renderIntemMissao.bind(this,elem++)))
            return <a href='javascript:void(0);' key={i} onClick={count} id={i} className={(i==0?"page active":"page")}>{i++}</a>;             
        });

        return <nav className='hud-pagination'>{retornoElem}</nav>
    }    

    renderIntemMissao(val,acao){
        $(".pageables").fadeOut("slow");
        this.setState({statusElem:(acao===1?1:null)});
        const dados = (acao == null ? this.props.all_missao.ativas : this.props.all_missao.inativas);
     
        if (dados.length>0) {

                    const ListaElemnt       = this.props.PaginateElement(dados,this.state.limitPag,val==undefined?1:val).itens;
                    const elementPagination = (this.paginacao(dados)); 
                    const retorno           = ListaElemnt.map((elem,i)=>{
                    const feedBack          = elem.ent_tar_feedback;
                    const status            = elem.tar_status;
                    const objStatus         = {}
                    
                    switch (status) {
                        
                         case 2:
                          objStatus.acao = "quest-inner-bar quest-inner-bar-acao active";
                        break;
                       
                        case 3:
                          objStatus.acao = "quest-inner-bar quest-inner-bar-acao active";
                        break;

                        case 4:
                          objStatus.acao = "quest-inner-bar quest-inner-bar-acao"; 
                        break;
                    
                        default:
                          objStatus.acao = "quest-inner-bar"; 
                        break;
                    }

                    return <div className="pageable col-6 active" key={i}>
                            <div className="quest" data-quest-progress="0">
                                <div className="quest-main">
                                    <div className="quest-content">
                                        <div className="quest-header">
                                            <div className="quest-actions">
                                                <Link to={`${this.props.menu.missao.concluir}/${elem.tar_id}`} className="action action-icon">
                                                    <i className="gamefica-icon gamefica-target"></i>
                                                </Link>
                                            </div>
                                            <div className="quest-bar">
                                                <div className={objStatus.acao}></div>
                                            </div>
                                        </div>
                                        <div className="quest-body">
                                            <div className="quest-title">
                                                {elem.tar_titulo}
                                            </div>
                                            <div className="quest-content">
                                               {elem.dis_nome}
                                            </div>
                                            <div className="actions" id={elem.tar_id}>
                                                
                                                <Link to={`${this.props.menu.missao.concluir}/${elem.tar_id}`} className="action">Abrir</Link>
                                                <AcaoMissao dados={elem}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="quest-right">
                                        <div className={`quest-marker ${elem.ent_tar_feedback?"active":"cursor-default"}`} onClick={feedBack ? this.click.bind(this,elem.tar_id) : void(0)}>
                                            <i className="gamefica-icon gamefica-message"></i>
                                        </div>
                                        <div className={`quest-marker cursor-default ${elem.ent_tar_pontuacao == null ? "" : "active"}`}>
                                            <span>{(elem.ent_tar_pontuacao !==null ?elem.ent_tar_pontuacao: "00")}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="quest-footer">
                                    até {moment(elem.tar_data_fim).format("DD/MM/YYYY")}
                                </div>
                            </div>
                            </div>            
                        });

                    const lista = <div><div className="row align-items-center pageables">{retorno}</div>{elementPagination}</div>;
                    this.setState({listaPagination:lista});    
                    $(".pageables").fadeIn("slow");                
                
            } else {
                const margin = {"margin": "0 auto"}
                const returnNull =  <img src={registro} style={margin} className="img-responsive" alt=""/>;

                this.setState({listaPagination:returnNull});    
            }
    }

    componentWillReceiveProps(nextProps){
        // if(this.state.load){
        //     this.renderIntemMissao(1,nextProps.checkSelect);
        // }
      
    }

    componentDidUpdate(){     
        $('.page').click(function(event){
            $('.page').removeClass('active');
            $(`#${$(this)[0].id}`).addClass('active');
       });
    }

    renderMissao(){


        const dados = (this.props.checkSelect == null ? this.props.all_missao.ativas : this.props.all_missao.inativas);
     
        if (dados.length>0) {                             
                    const retorno           = dados.map((elem,i)=>{
                    const feedBack          = elem.ent_tar_feedback;
                    const status            = elem.tar_status;
                    const objStatus         = {}
                    
                    switch (status) {
                        
                         case 2:
                          objStatus.acao = "quest-inner-bar quest-inner-bar-acao active";
                        break;
                       
                        case 3:
                          objStatus.acao = "quest-inner-bar quest-inner-bar-acao active";
                        break;

                        case 4:
                          objStatus.acao = "quest-inner-bar quest-inner-bar-acao"; 
                        break;
                    
                        default:
                          objStatus.acao = "quest-inner-bar"; 
                        break;
                    }

                    return <div className="pageable col-6 active" key={i}>
                            <div className="quest" data-quest-progress="0">
                                <div className="quest-main">
                                    <div className="quest-content">
                                        <div className="quest-header">
                                            <div className="quest-actions">
                                                <Link to={`${this.props.menu.missao.concluir}/${elem.tar_id}`} className="action action-icon">
                                                    <i className="gamefica-icon gamefica-target"></i>
                                                </Link>
                                            </div>
                                            <div className="quest-bar">
                                                <div className={objStatus.acao}></div>
                                            </div>
                                        </div>
                                        <div className="quest-body">
                                            <div className="quest-title">
                                                {elem.tar_titulo}
                                            </div>
                                            <div className="quest-content">
                                               {elem.dis_nome}
                                            </div>
                                            <div className="actions" id={elem.tar_id}>
                                                
                                                <Link to={`${this.props.menu.missao.concluir}/${elem.tar_id}`} className="action">Abrir</Link>
                                                <AcaoMissao dados={elem}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="quest-right">
                                        <div className={`quest-marker ${elem.ent_tar_feedback?"active":"cursor-default"}`} onClick={feedBack ? this.click.bind(this,elem.tar_id) : void(0)}>
                                            <i className="gamefica-icon gamefica-message"></i>
                                        </div>
                                        <div className={`quest-marker cursor-default ${elem.ent_tar_pontuacao == null ? "" : "active"}`}>
                                            <span>{(elem.ent_tar_pontuacao !==null ?elem.ent_tar_pontuacao: "00")}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="quest-footer">
                                    até {moment(elem.tar_data_fim).format("DD/MM/YYYY")}
                                </div>
                            </div>
                            </div>            
                        });

                   return <div className="row align-items-center pageables">{retorno}</div>;
                
            } else {
                const margin = {"margin": "0 auto"}
                return <img src={registro} style={margin} className="img-responsive" alt=""/>;               
            }

    }

    render(){
        if (this.state.acao) {
        return (<Redirect to={`${this.props.menu.missao.recompensa}/${this.state.tar_id}`}/>);
        }

        return(
            <div className="hud-middle-center active">
                <RenderHeader titulo="Missões"/>
                <main className="hud-middle-center-content">
                    <RenderFilter/>
                    {this.state.load?  this.renderMissao(): <FlashCarregando/>}
                </main>
            </div>              
        );
    }
}

function mapStateToProps(state){

    return {
            session: state.auth.session,
            menu: state.configReducer.menu,
            checkSelect: state.scopoReducer.checkSelect,
            all_missao: state.tarefaReducer.all_tarefas_aluno
           }

}

export default connect(mapStateToProps, { GetActionBg,GetTarefasAluno,SetError,GetCheckSelect,PaginateElement})(Tarefas_Aluno);





// WEBPACK FOOTER //
// ./src/components/aluno/missao/missao.js